import { BasePagePath } from "app/core/workflow/page-path/base-page.path";

export class UserProfilePagePath extends BasePagePath {
  public static path(): string {
    return "my-profile";
  }
}
